import classNames from 'classnames';

import { CURRENCY_NO_CENTS, RANGE_SEPARATOR, SPACE, UNIT_MEASURE } from '@common/constants';
import formatUOM from '@common/helpers/formatUOM';
import { MaterialModel } from '@common/models';
import ImageUtils from '@core/utils/ImageUtils';

import ProductSpecification from '../product-specification/product-specification';

import './material-card.scss';

interface MaterialCardProps {
    material: MaterialModel;
    selected?: boolean;
    onClick?: () => void;
}

const MaterialCard = ({ material, selected, onClick }: MaterialCardProps): JSX.Element => {
    const MinMaxPriceLabel = ({ material }: { material: MaterialModel }): JSX.Element => (
        <div className="material-price">
            {CURRENCY_NO_CENTS.format(Math.floor(Number(material.minPrice)))}
            {RANGE_SEPARATOR}
            {CURRENCY_NO_CENTS.format(Math.ceil(Number(material.maxPrice)))}
            {SPACE}
            {formatUOM(UNIT_MEASURE.MATERIALS)}
        </div>
    );

    const renderMaterialAttributes = (material: MaterialModel): JSX.Element => (
        <ul className="material-card__specifications">
            {material.attributes.length
                ? material.attributes.map(({ description, score }, index) => (
                      <ProductSpecification key={index} description={description} score={score} />
                  ))
                : null}
        </ul>
    );

    return (
        <article
            className={classNames('material-card single-action-card', { 'material-card--selected': selected })}
            onClick={onClick}
        >
            <figure>
                <img className="material-card__image" src={ImageUtils.imgUrl(material.imageUrl, 600)} alt="" />
            </figure>
            <div className="material-card__content">
                <h1 className="material-card__title">{material.description}</h1>
                <div className="material-card__price-range">
                    <label htmlFor="">Price Range</label>
                    <MinMaxPriceLabel material={material} />
                </div>
                <h2 className="material-card__subtitle">Product Specifications</h2>
                {renderMaterialAttributes(material)}
            </div>
        </article>
    );
};

export default MaterialCard;
